export default "__VITE_ASSET__CibbMCgL__"